import { useMemo } from "react";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useGatheringHomeNumColumnsRange from "src/screens/(internal)/(GatheringHome)/_/hooks/useGatheringHomeNumColumnsRange";

const useGatheringHomeNumColumns = () => {
	const { minNumColumns, defaultNumColumns, maxNumColumns } = useGatheringHomeNumColumnsRange();
	const numColumnsTarget = useGatheringStore((state) => state.numColumnsTarget);

	const numColumns = useMemo(() => {
		const goalNumColumns = numColumnsTarget ?? defaultNumColumns;
		return Math.max(Math.min(goalNumColumns, maxNumColumns), minNumColumns);
	}, [numColumnsTarget, minNumColumns, defaultNumColumns, maxNumColumns]);

	return numColumns;
};
export default useGatheringHomeNumColumns;
